import { EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { param } from 'jquery';

@Component({
  selector: 'app-chat-subtopic',
  templateUrl: './chat-subtopic.component.html',
  styleUrls: ['./chat-subtopic.component.scss'],
})
export class ChatSubtopicComponent implements OnInit {
  @Input() subtopic: {
    subtopic: string;
    dateCreated: string;
    createdBy: string;
    topic: string;
    subtopicId: string;
  };
  @Input() parentTopic: string;
  @Input() activatedSubtopicId: string;
  @Input() disabled: boolean;
  @Output() onEdit = new EventEmitter();
  @Output() onView = new EventEmitter();
  @Output() onDelete = new EventEmitter();
  @Output() onAdd = new EventEmitter();

  @Output() viewAssignedUsers = new EventEmitter();

  @Input() isSelected: any;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {}

  viewUsers(item) {
    this.viewAssignedUsers.emit(item);
    // console.log(item)
  }

  isActive(subtopicId: string) {
    let p = this.activatedRoute.snapshot.queryParamMap.get('subtopicId');
    if (subtopicId === p) {
      return true;
    } else {
      return false;
    }
  }
}
